import { useState, useEffect } from 'react';
import _ from 'lodash';

interface Options {
  config?: {
    attributes?: boolean,
    childList?: boolean,
    subtree?: boolean
  },
  debounceTime?: number
}

const DEFAULT_OPTIONS = {
  config: { attributes: true, childList: false, subtree: false },
  debounceTime: 0
};

export default function useMutationObservable(
  targetEl: HTMLElement,
  cb: (mutationList: MutationRecord[]) => void, // eslint-disable-line no-unused-vars
  options?: Options
) {
  const [observer, setObserver] = useState<MutationObserver>(null);

  const opts = Object.assign(DEFAULT_OPTIONS, options);

  useEffect(() => {
    const obs = new MutationObserver(opts.debounceTime > 0 ? _.debounce(cb, opts.debounceTime) : cb);
    setObserver(obs);
  }, [cb, opts, setObserver]);

  useEffect(() => {
    if (observer) {
      try {
        observer.observe(targetEl, opts.config);
      } catch (e) {
        console.error(e);
      }
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [observer, targetEl, opts]);
}
